import { Button } from '@/components/ui/button';
import { useItemStore } from '@/store';
import { cn } from 'lib/utils';

type NameCellProps = {
  id: number;
  name: string;
  className?: string;
};

export function ItemNameLinkCell({ id, name, className }: NameCellProps) {
  const { openItemDialog } = useItemStore();

  return (
    <div className={cn('flex items-center justify-start gap-2', className)}>
      <Button
        variant="link"
        size="default"
        className="line-clamp-2 font-sans text-sm"
        onClick={() => {
          openItemDialog(id);
        }}
      >
        {name}
      </Button>
    </div>
  );
}
